<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter">
<p class="firstInSection">On one side lay the Ocean, and on one<br/>
Lay a great water, and the moon was full.</p>
<p class="attribution"><b>Alfred, Lord Tennyson</b>, <em>Idylls of the King</em></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter2.vue?05a77ff1